export const BUDGET_BASE_ROUTE = '/wedding/manage/budget';
